import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab } from '@mercai/clever'

import styles from './finance-form.module.css'
import type { FinanceFormProps, FinanceFormTabsEnum } from './finance-form.type'
import type { SaleOrderProps } from '@/types'

import {
  FinaceDocumentsTab,
  FinanceInvoicesTab,
  FinancePaymentTab,
} from './components'

export const FinanceForm = ({
  onChange,
  values = {} as SaleOrderProps,
  onSuccessUploadFiles,
  initialTab = 'payments',
}: FinanceFormProps) => {
  const { t } = useTranslation('componentOrderCenterForm')

  const [tab, setTab] = useState(initialTab)

  const tabsContent: Record<keyof typeof FinanceFormTabsEnum, React.ReactNode> =
    {
      payments: (
        <FinancePaymentTab
          onChange={onChange}
          values={values}
          onSuccessUploadFiles={onSuccessUploadFiles}
        />
      ),
      invoices: (
        <FinanceInvoicesTab
          onChange={onChange}
          values={values}
          onSuccessUploadFiles={onSuccessUploadFiles}
        />
      ),
      documents: (
        <FinaceDocumentsTab
          values={values}
          onSuccessUploadFiles={onSuccessUploadFiles}
        />
      ),
    }

  return (
    <div className={styles.core}>
      <Tab
        items={[
          {
            label: t('financeTabInvoices'),
            value: 'invoices',
          },
          {
            label: t('financeTabPayments'),
            value: 'payments',
          },
          {
            label: t('financeTabDocuments'),
            value: 'documents',
          },
        ]}
        onChange={(value) => setTab(value as keyof typeof FinanceFormTabsEnum)}
        value={tab}
      />

      {tabsContent[tab]}
    </div>
  )
}
